import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  "class": "dashboard fs_box_wrapper"
};
var _hoisted_2 = {
  "class": "fs_box fs_dashboard_box fs_box_narrow"
};
var _hoisted_3 = {
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_4 = {
  "class": "fcon_inner_table_wrap"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = ["href"];
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  "class": "fframe_pagination_wrapper",
  style: {
    "margin-top": "20px",
    "text-align": "right"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_pagination = _resolveComponent("pagination");
  var _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    "class": "fs_box_header",
    style: {
      "padding": "10px 15px",
      "font-size": "16px"
    }
  }, [_createElementVNode("div", {
    "class": "fs_box_head"
  }, [_createElementVNode("h3", null, "All Trigger & Action Logs")])], -1 /* HOISTED */)), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_table, {
    stripe: "",
    border: "",
    data: $data.logs
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        type: "expand"
      }, {
        "default": _withCtx(function (scope) {
          return [_createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("h3", null, "Actions", -1 /* HOISTED */)), _createVNode(_component_el_table, {
            data: scope.row.action_logs,
            stripe: ""
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                label: "Action"
              }, {
                "default": _withCtx(function (scope) {
                  return [scope.row.reference_url ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createElementVNode("a", {
                    target: "_blank",
                    rel: "noopener",
                    href: scope.row.reference_url
                  }, _toDisplayString(scope.row.description), 9 /* TEXT, PROPS */, _hoisted_6)])) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.description), 1 /* TEXT */))];
                }),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */), _createVNode(_component_el_table_column, {
                width: 100,
                prop: "status",
                label: "Status"
              }), _createVNode(_component_el_table_column, {
                width: 160,
                prop: "created_at",
                label: "Date Time"
              })];
            }),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data"])])];
        }),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_table_column, {
        width: 80,
        label: "ID",
        prop: "id"
      }), _createVNode(_component_el_table_column, {
        label: "Trigger"
      }, {
        "default": _withCtx(function (scope) {
          var _scope$row$trigger;
          return [_createTextVNode(_toDisplayString(((_scope$row$trigger = scope.row.trigger) === null || _scope$row$trigger === void 0 ? void 0 : _scope$row$trigger.title) || 'Unknown'), 1 /* TEXT */)];
        }),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_table_column, {
        width: 150,
        label: "Provider"
      }, {
        "default": _withCtx(function (scope) {
          var _scope$row$trigger2;
          return [_createTextVNode(_toDisplayString(((_scope$row$trigger2 = scope.row.trigger) === null || _scope$row$trigger2 === void 0 ? void 0 : _scope$row$trigger2.trigger_provider) || 'Unknown'), 1 /* TEXT */)];
        }),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_table_column, {
        width: 100,
        label: "Status",
        prop: "status"
      }), _createVNode(_component_el_table_column, {
        width: 160,
        label: "Date Time",
        prop: "created_at"
      })];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data"]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_pagination, {
    onFetch: _cache[0] || (_cache[0] = function ($event) {
      return $options.fetch();
    }),
    pagination: $data.pagination
  }, null, 8 /* PROPS */, ["pagination"])])])), [[_directive_loading, $data.loading]])])]);
}